import { render, staticRenderFns } from "./SwvFruehstueck2026.vue?vue&type=template&id=73f0e2a9&scoped=true"
import script from "./SwvFruehstueck2026.vue?vue&type=script&lang=js"
export * from "./SwvFruehstueck2026.vue?vue&type=script&lang=js"
import style0 from "./SwvFruehstueck2026.vue?vue&type=style&index=0&id=73f0e2a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f0e2a9",
  null
  
)

export default component.exports